import {
  INSERT_TABLE_COMMAND
} from '@lexical/table'

export const handleClick = ({ editor }) => {
  editor.dispatchCommand(INSERT_TABLE_COMMAND, {columns: 4, rows: 4})
};
